import { getAdminApiKey } from "./admin-settings.js";
import { getAdminJwt } from "./auth-storage.js";

/**
 * Legacy dev path: governance via `ADMIN_API_KEY` without operator JWT login.
 */
export function isLegacyGovernanceMode(): boolean {
  return !getAdminJwt() && Boolean(getAdminApiKey());
}
